import { Component, Input, TemplateRef } from '@angular/core';
import { HistoryResponse } from '../../models/history';
import {DateTime} from "luxon";
import {DownloadService} from "@shared/services/download.service";
import * as XLSX from 'xlsx';

const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

@Component({
  selector: 'lib-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})

export class HistoryComponent {
  @Input() changeHistory: HistoryResponse[];
  @Input() actionTemplate?: TemplateRef<unknown>;
  @Input() label: string;

  constructor(private downloadService: DownloadService) {}

  get filteredChangeHistory(): HistoryResponse[] {
    return this.changeHistory.map(historyEntry => {
      return {
        ...historyEntry,
        history: Object.fromEntries(
          Object.entries(historyEntry.history)
          .filter(([key, val]) => !["LastChangedBy", "LastChanged"].includes(key))
        )
      };
    });
  }

  historyTrackBy(_i: number, item: HistoryResponse): string {
    return item.entityId + item.action + item.timestamp;
  }

  format(value: unknown): unknown {
     if (!value) return value;

     const dateFormat = 'M/d/yy HH:mm:ss ZZ';

     if(DateTime.isDateTime(value)) {
        return value.toLocal().toFormat(dateFormat);
     }

     const val = value.toString();
     const isoDate = DateTime.fromFormat(val, "yyyy-MM-dd'T'HH:mm:ssZZ", {});
     if (isoDate.isValid) {
         return isoDate.toLocal().toFormat(dateFormat);
     }

     return value;
  }

    exportToExcel() {
        let worksheets: XLSX.WorkSheet[] = [];
        let sheetNames: string[] = [];
        let increment = 0
        this.changeHistory.forEach(ch => {
            const sheetName = `${++increment} ${ch.action} ${ch.dataType}`;
            worksheets.push(XLSX.utils.json_to_sheet([ch.history]));
            sheetNames.push(`${sheetName.substring(0, 31)}`);
        });
        const workbook: XLSX.WorkBook = XLSX.utils.book_new();
        worksheets.forEach((ws, i) => XLSX.utils.book_append_sheet(workbook, ws, sheetNames[i]))

        const buffer: any = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'});
        const blob = new Blob([buffer], {type: EXCEL_TYPE})
        this.downloadService.Download(blob, `history for ${this.label}`);
    }

    /***
        * This function is used to change the foreign key name suffix to a more user friendly name
        *  (e.g. `Trailer Id` to `Trailer Database Id`)
        * @param val
        */
    changeForeignKeyNameSuffix(val: string): string {
      return val.replace(/Id$/, ' Database Id');
    }
}
